import React, { useState } from 'react';
import { useAtividade } from '../../contexts/AtividadeContext';
import { useNavigate } from 'react-router-dom';

const AtividadeNotificacao: React.FC = () => {
  const { atividades, atividadesNaoLidas, marcarComoLida, marcarTodasComoLidas } = useAtividade();
  const [menuAberto, setMenuAberto] = useState(false);
  const navigate = useNavigate();

  const formatarTempoRelativo = (data_hora: string) => {
    const data = new Date(data_hora);
    const agora = new Date();
    const diff = agora.getTime() - data.getTime();
    
    // Converter para minutos, horas, dias
    const minutos = Math.floor(diff / 60000);
    const horas = Math.floor(minutos / 60);
    const dias = Math.floor(horas / 24);
    
    if (dias > 0) {
      return dias === 1 ? 'há 1 dia' : `há ${dias} dias`;
    } else if (horas > 0) {
      return horas === 1 ? 'há 1 hora' : `há ${horas} horas`;
    } else if (minutos > 0) {
      return minutos === 1 ? 'há 1 minuto' : `há ${minutos} minutos`;
    } else {
      return 'agora mesmo';
    }
  };

  const handleVerTarefa = (tarefaId: string) => {
    if (!tarefaId) return;
    setMenuAberto(false);
    navigate(`/tarefas/${tarefaId}`);
  };

  return (
    <div className="relative">
      <button
        className="relative p-1 rounded-full text-gray-600 hover:text-gray-800 dark:text-gray-300 dark:hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 notification-bell"
        onClick={() => setMenuAberto(!menuAberto)}
        aria-label="Notificações"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
        </svg>
        
        {atividadesNaoLidas > 0 && (
          <span className="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white transform translate-x-1/2 -translate-y-1/2 bg-red-500 rounded-full">
            {atividadesNaoLidas > 9 ? '9+' : atividadesNaoLidas}
          </span>
        )}
      </button>

      {menuAberto && (
        <div className="absolute right-0 mt-2 w-80 bg-white rounded-md shadow-lg z-50 overflow-hidden">
          <div className="p-3 border-b border-gray-200 flex justify-between items-center">
            <h3 className="text-sm font-medium text-gray-700">Notificações</h3>
            {atividadesNaoLidas > 0 && (
              <button 
                onClick={() => {
                  marcarTodasComoLidas();
                  setMenuAberto(false);
                }}
                className="text-xs text-blue-600 hover:text-blue-800"
              >
                Marcar todas como lidas
              </button>
            )}
          </div>
          
          <div className="max-h-96 overflow-y-auto">
            {atividades.length === 0 ? (
              <div className="p-4 text-center text-gray-500">
                Nenhuma notificação
              </div>
            ) : (
              <div>
                {atividades.slice(0, 5).map((atividade) => (
                  <div 
                    key={atividade.id}
                    className={`p-3 border-b border-gray-100 ${!atividade.lida ? 'bg-blue-50' : ''}`}
                  >
                    <div className="flex items-start">
                      <div className="flex-shrink-0">
                        <img 
                          src="/profilepicture.png" 
                          alt={atividade.usuario_origem_nome || 'Avatar'} 
                          className="h-8 w-8 rounded-full"
                        />
                      </div>
                      <div className="ml-3 flex-1">
                        <div className="text-sm font-medium text-gray-900">
                          {atividade.titulo}
                        </div>
                        <p className="text-xs text-gray-600 mt-0.5 line-clamp-2">
                          {atividade.descricao}
                        </p>
                        <div className="mt-1 flex justify-between items-center">
                          <span className="text-xs text-gray-500">
                            {formatarTempoRelativo(atividade.data_hora)}
                          </span>
                          {!atividade.lida && (
                            <button
                              onClick={() => marcarComoLida(atividade.id)}
                              className="text-xs text-blue-600 hover:text-blue-800"
                            >
                              Marcar como lida
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="mt-2 flex justify-end">
                      <button
                        onClick={() => handleVerTarefa(atividade.tarefa_id || '')}
                        className="text-xs bg-blue-50 hover:bg-blue-100 text-blue-700 px-2 py-1 rounded"
                      >
                        Ver tarefa
                      </button>
                    </div>
                  </div>
                ))}
                
                {atividades.length > 5 && (
                  <div className="p-2 text-center">
                    <button 
                      onClick={() => navigate('/atividades')}
                      className="text-xs text-blue-600 hover:text-blue-800"
                    >
                      Ver todas as notificações
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AtividadeNotificacao;
